import { Button, ButtonProps } from '@axo/ui-core/components/Button';
import { Icon } from '@axo/ui-core/components/Icon';
import { ReactNode } from 'react';
import styles from './navigation.module.scss';

type BackProps = {
  children: ReactNode;
  onClick: () => void;
  variant?: 'tertiary' | 'ghost';
  size?: 'large' | 'small';
};
const Back = ({
  children,
  variant = 'ghost',
  size = 'large',
  onClick,
}: BackProps) => {
  // backward-compatible
  // ghost + small = mini-variant
  // ghost by default
  const isMiniVariant = variant === 'ghost' && size === 'small';
  // new button sizes
  const sizeConversion = size === 'large' ? 'm' : 's';

  return (
    <Button
      type="button"
      className={styles.back}
      prefix={
        <Icon name={isMiniVariant ? 'chevron-left' : 'arrow-left'} size="xs" />
      }
      onClick={onClick}
      data-variant={variant}
      data-size={sizeConversion}
      data-mini-variant={isMiniVariant ? '' : undefined}
    >
      {children}
    </Button>
  );
};

type ContinueProps = {
  children: ReactNode;
  size?: Extract<ButtonProps['size'], 'l' | 'xl'>;
  loading?: boolean;
};
const Continue = ({ children, loading, size = 'l' }: ContinueProps) => {
  return (
    <Button
      type="submit"
      className={styles.continue}
      variant="primary"
      size={size}
      loading={loading}
      suffix={<Icon name="arrow-right" />}
      data-testid="button-submit"
    >
      {children}
    </Button>
  );
};

export const Navigation = {
  Back,
  Continue,
};
